export default __webpack_public_path__ + "static/media/people.bg.e7f41b16.svg";